import Vue from 'vue'
// highlight code
Vue.directive('highlight', {
    inserted(el) {
        const els = el.querySelectorAll('pre code');

        els.length && import(/* webpackChunkName: "lib/highlight/highlight" */ '@/lib/highlight/highlight.min').then((module) => {
            const hljs = module;

            for (let i = els.length - 1; i >= 0; i--) {
                hljs.highlightBlock(els[i]);
            }
        });
    }
});

// //还需要JQUERY
// Vue.directive('image-viewer', {
//     inserted (el, binding, { context }) {
//         require('lib/image-viewer/viewer.min.css');
//         import(/* webpackChunkName: 'lib/image-viewer/viewer.min' */ '@/lib/image-viewer/viewer.min.js').then(() => {
//             context.$nextTick(() => $('.image-viewer').viewer({url: 'data-origin'}));
//         });
//     }
// });

// 解析多个腾讯视频，目前用于文档、论坛
Vue.directive('tencent-videos', {
    inserted(el) {
        const $videoLink = el.querySelectorAll('.swan-video-link-container');
        const txPlayerFunc = () => {
            for (let i = 0, len = $videoLink.length; i < len; i++) {
                let video = $videoLink[i];
                let videoId = video.id && video.id.match(/video-link-([a-zA-z0-9]+)/) ? video.id.match(/video-link-([a-zA-z0-9]+)/)[1] : 0;
                let width = video.parentNode.clientWidth || (document.body.clientWidth - 30);
                let height = Math.round(width * 9 / 16);

                if (videoId) {
                    video.outerHTML = `<div class="swan-video-link-container" id="swan-video-link-${ videoId }"></div>`;
                    new Txplayer({
                        containerId: `swan-video-link-${ videoId }`,
                        vid: videoId,
                        width: width,
                        height: height
                    });
                }
            }
        };

        if (typeof Txplayer == 'function') {
            txPlayerFunc();
        } else {
            let txPlayerScript = document.createElement('script');
            txPlayerScript.src = '//vm.gtimg.cn/tencentvideo/txp/js/txplayer.js';
            document.body.appendChild(txPlayerScript);
            txPlayerScript.onload = () => {
                txPlayerFunc();
            };
        }
    }
});


// 解析多个视频，目前用于文档
let tcPlayerVideos = [];
Vue.directive('videos', {
    inserted(el, binding, {context}) {
        const $video = el.querySelectorAll('.swan-video-container');
        const $videoLink = el.querySelectorAll('.swan-video-link-container');

        const renderErrorHtml = (width, height, errorText) => {
            return `
                <div class="swan-video-container error" style="width: ${width}px; height: ${height}px;">
                    <div class="video-wording" style="width: ${width}px;height: ${height}px;line-height: ${height}px;">${errorText}</div>
                </div>
            `;
        };

        const renderSuccessHtml = (fileId, width, height) => {
            return `
                <video class="swan-video-container" id="swan-video-${ fileId }" style="width: ${ width}px; height: ${ height }px;" 
                        playsinline webkit-playinline x5-playinline></video>
            `;
        };

        let link = document.createElement('link');
        link.href = '//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css';
        link.rel = 'stylesheet';
        document.body.appendChild(link);

        let tcPlayerRources = ['//imgcache.qq.com/open/qcloud/video/tcplayer/lib/hls.min.0.8.8.js',
                              '//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.min.js'];
        let tcPlayerScript;
        tcPlayerRources.forEach(source => {
            tcPlayerScript = document.createElement('script');
            tcPlayerScript.src = source;
            document.body.appendChild(tcPlayerScript);
        });
        tcPlayerScript.onload = () => {
            for (let i = 0, len = $video.length; i < len; i++) {
                let video = $video[i];
                let videoId = video.id && video.id.match(/video-(\w+)/) ? video.id.match(/video-(\w+)/)[1] : 0;
                let width = video.parentNode.clientWidth || (document.body.clientWidth - 30);
                let height = Math.round(width * 9 / 16);

                if (videoId) {
                    context.$http.get(`/api/v1/videos/${ videoId }/play-signature`).then(({data}) => {
                        if (data.status === 'converted' && typeof TCPlayer == 'function') { // 转码成功
                            const config = {
                                appID: data.app_id,
                                fileID: data.file_id,
                                width: width,
                                height: height,
                                preload: 'none',
                                t: data.t,
                                us: data.us,
                                sign: data.sign,
                                plugins: {
                                    ContinuePlay: {}
                                }
                            };
                            video.outerHTML = renderSuccessHtml(videoId, width, height);
                            tcPlayerVideos.push(TCPlayer(video.id, config));
                        } else if (data.status === 'failed') {
                            video.outerHTML = renderErrorHtml(width, height, '转码失败, 需重新上传');
                        } else {
                            video.outerHTML = renderErrorHtml(width, height, '正在转码中...');
                        }
                    }).catch(() => {
                        video.outerHTML = renderErrorHtml(width, height, '找不到视频, 需重新上传');
                    });
                }
            }
        };

        let txPlayerScript = document.createElement('script');
        txPlayerScript.src = '//vm.gtimg.cn/tencentvideo/txp/js/txplayer.js';
        document.body.appendChild(txPlayerScript);
        txPlayerScript.onload = () => {
            for (let i = 0, len = $videoLink.length; i < len; i++) {
                let video = $videoLink[i];
                let videoId = video.id && video.id.match(/video-link-([a-zA-z0-9]+)/) ? video.id.match(/video-link-([a-zA-z0-9]+)/)[1] : 0;
                let width = video.parentNode.clientWidth || (document.body.clientWidth - 30);
                let height = Math.round(width * 9 / 16);

                if (videoId) {
                    video.outerHTML = `<div class="swan-video-link-container" id="swan-video-link-${ videoId }"></div>`;
                    new Txplayer({
                        containerId: `swan-video-link-${ videoId }`,
                        vid: videoId,
                        width: width,
                        height: height
                    });
                }
            }
        };
    },
    unbind () {
        tcPlayerVideos.forEach(video => {
            video && video.dispose();
        });
    }
});

// 解析多个音频，目前用于文档
Vue.directive('audios', {
    inserted(el) {
        const $audio = el.querySelectorAll('.swan-audio-container');

        for (let i = 0, len = $audio.length; i < len; i++) {
            let audio = $audio[i];
            let audioId = audio.id && audio.id.match(/audio-([a-zA-z0-9]+)/) ? audio.id.match(/audio-([a-zA-z0-9]+)/)[1] : 0;

            if (audioId) {
                audio.outerHTML = `<div class="swan-audio-container" id="swan-audio-${ audioId }">
                                        <audio src="/assets/${ audioId }" controls controlsList="nodownload">您的浏览器不支持音频播放</audio>
                                    </div>`;
            }
        }
    }
});

// 解析单个视频，目前用于课堂
Vue.directive('video', {
    bind (el, { value }, { context }) {
        context.$nextTick(() => {
            axios.get(`/api/v1/videos/${ value.video.id }/play-signature`).then(({ data }) => {
                const player = TCPlayer(el.id, {
                    appID: data.app_id,
                    fileID: data.file_id,
                    width: 1060,
                    height: 596,
                    poster: value.video.vod_cover_url,
                    t: data.t,
                    us: data.us,
                    sign: data.sign,
                    plugins: {
                        ContinuePlay: {}
                    }
                });
                let intervalID;

                if (value.clazz_id) {
                    player.on('play', () => {
                        axios.put(`/api/v1/classes/${ value.clazz_id }/join`).then(() => {});

                        intervalID = setInterval(() => {
                            let learnTime = Math.floor(player.currentTime());

                            learnTime ? axios.post(`/api/v1/classes/${ value.clazz_id }/study`, {
                                learn_time: learnTime
                            }).then(() => {}) : null;
                        }, 1000 * 30);
                    });
                    player.on('pause', () => {
                        clearInterval(intervalID);
                    });
                }
            });
        });
    }
});

Vue.directive('lazy-load', {
    bind (el, value, { context }) {
        context.$nextTick(() => {
            const images = el.querySelectorAll('img');
            const lazyLoad = () => {
                for (let i = 0; i < images.length; i++) {
                    const parentNode = images[i].parentNode || el;
                    const containerPadding = window.getComputedStyle ? ( parseInt(window.getComputedStyle(parentNode)['padding-left']) + parseInt(window.getComputedStyle(parentNode)['padding-right']) ) : 0;
                    const containerWidth = (parentNode.clientWidth - containerPadding) || el.clientWidth;
                    const imageData = images[i].dataset;
                    const isProp = images[i].getAttribute('width') && images[i].getAttribute('height');
                    let width = Number(isProp ? images[i].getAttribute('width') : imageData.width);
                    let height = Number(isProp ? images[i].getAttribute('height') : imageData.height);
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const winHeight = window.innerHeight || document.documentElement.clientHeight;
                    const originBackgroundColor = images[i].style.backgroundColor || 'transparent';

                    if (width > containerWidth) {
                        height = containerWidth * height / width;
                        width = containerWidth;
                    }

                    if (width && height) {
                        images[i].setAttribute('alt', '');
                        images[i].style.width = `${ width }px`;
                        images[i].style.height = `${ height }px`;
                    }

                    if (!images[i].getAttribute('src') && imageData.src && images[i].offsetTop <= scrollTop + winHeight + 100) {
                        images[i].setAttribute('src', imageData.src);
                    }

                    images[i].addEventListener('load', () => {
                        images[i].style.backgroundImage = 'none';
                        images[i].style.backgroundColor = originBackgroundColor;
                    });
                }
            };

            lazyLoad();

            const scrollCallback = () => lazyLoad();
            document.addEventListener('scroll', scrollCallback);

            el.scrollCallback = scrollCallback;
        });
    },
    unbind(el, value, { context }) {
        document.removeEventListener('scroll', el.scrollCallback);
        delete el.scrollCallback;
    }
});


